const { cl } = require('./defaults/default-cl');
const { pe } = require('./defaults/default-pe');
const { co } = require('./defaults/default-co');

export const siteConfig = { cl, co, pe };
